// TOKEN ACTIONS
export const ADD_TOKEN = "ADD_TOKEN";
export const DELETE_TOKEN = "DELETE_TOKEN";
export const GET_INITIAL_TOKEN = "GET_INITIAL_TOKEN";

// API CALLS ACTIONS
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const STARTED = "STARTED";
export const DELETE = "DELETE";

//AUTH ACTIONS
export const LOGIN_REQUEEST = "LOGIN_REQUEEST";
export const LOGOUT_REQUEEST = "LOGOUT_REQUEEST";
export const IS_USER_LOGGEDIN = "IS_USER_LOGGEDIN";
export const IS_USER_VERIFIED = "IS_USER_VERIFIED";

//BRANCH ACTIONS
export const ADD_BRANCH = "ADD_BRANCH";
export const EDIT_BRANCH = "EDIT_BRANCH";
export const GET_BRANCH = "GET_BRANCH";
export const BLOCK_BRANCH = "BLOCK_BRANCH";
export const DELETE_BRANCH = "DELETE_BRANCH";

//BRANCH MANAGER ACTIONS
export const ADD_BRANCH_MANAGER = "ADD_BRANCH_MANAGER";
export const EDIT_BRANCH_MANAGER = "EDIT_BRANCH_MANAGER";
export const GET_BRANCH_MANAGER = "GET_BRANCH_MANAGER";
export const DELETE_BRANCH_MANAGER = "DELETE_BRANCH_MANAGER";
export const BLOCK_BRANCH_MANAGER = "BLOCK_BRANCH_MANAGER";

//BRANCH OFFICER ACTIONS
export const ADD_BRANCH_OFFICER = "ADD_BRANCH_OFFICER";
export const EDIT_BRANCH_OFFICER = "EDIT_BRANCH_OFFICER";
export const GET_BRANCH_OFFICER = "GET_BRANCH_OFFICER";
export const DELETE_BRANCH_OFFICER = "DELETE_BRANCH_OFFICER";
export const BLOCK_BRANCH_OFFICER = "BLOCK_BRANCH_OFFICER";

//REVIEWER ACTIONS
export const ADD_REVIEWER = "ADD_REVIEWER";
export const EDIT_REVIEWER = "EDIT_REVIEWER";
export const GET_REVIEWER = "GET_REVIEWER";
export const BLOCK_REVIEWER = "BLOCK_REVIEWER";
export const DELETE_REVIEWER = "DELETE_REVIEWER";
export const REVIEWED_APPLICATION = "REVIEWED_APPLICATION";

//APPLICANT ACTIONS
export const ADD_APPLICANT = "ADD_APPLICANT";
export const GET_APPLICATION = "GET_APPLICATION";
export const UPDATE_INSPECTION_STATUS = "UPDATE_INSPECTION_STATUS";
export const REVIEW_APPLICATION = "REVIEW_APPLICATION";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const ACTIVATE_ACCOUNT = "ACTIVATE_ACCOUNT";

//CS AGENT ACTIONS
export const ADD_AGENT = "ADD_AGENT";
export const EDIT_AGENT = "EDIT_AGENT";
export const GET_AGENT = "GET_AGENT";
export const BLOCK_AGENT = "BLOCK_AGENT";
export const DELETE_AGENT = "DELETE_AGENT";

// CS AGENT APPLICATION ACTIONS
export const ADD_AGENT_USER = "ADD_AGENT_USER";
export const EDIT_AGENT_USER = "EDIT_AGENT_USER";
export const GET_AGENT_USER = "GET_AGENT_USER";
export const BLOCK_AGENT_USER = "BLOCK_AGENT_USER";
export const DELETE_AGENT_USER = "DELETE_AGENT_USER";

